// extracted by mini-css-extract-plugin
export var formContainer = "_fg-0";
export var message = "_fg-1";